import api from '@/api/api';

class ProjetoComentariosService {
    getComentarios(empresaId, projetoId) {
        return api.get(`/v1/projetos/${empresaId}/enquadrados/${projetoId}/comentarios`);
    }

    createComentario(empresaId, projetoId, dados) {
        return api.post(`/v1/projetos/${empresaId}/enquadrados/${projetoId}/comentarios`, dados);
    }

    resolverComentarios(empresaId, projetoId, campoIdentificador) {
        return api.put(`/v1/projetos/${empresaId}/enquadrados/${projetoId}/comentarios/${campoIdentificador}/resolver`, {});
    }
}

export default new ProjetoComentariosService();
